var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7383 13.217C25.7383 6.10963 19.9766 0.347862 12.8692 0.347862C5.76177 0.347862 0 6.10953 0 13.217C0 19.6404 4.7061 24.9645 10.8584 25.9299V16.937H7.5908V13.217H10.8584V10.3818C10.8584 7.15646 12.7797 5.37488 15.7192 5.37488C17.1273 5.37488 18.6 5.62623 18.6 5.62623V8.79326H16.9773C15.3785 8.79326 14.88 9.78529 14.88 10.8031V13.217H18.4492L17.8786 16.937H14.88V25.9299C21.0323 24.9645 25.7383 19.6405 25.7383 13.217Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8786 16.937L18.4491 13.217H14.8799V10.8031C14.8799 9.78519 15.3785 8.79326 16.9772 8.79326H18.5999V5.62624C18.5999 5.62624 17.1272 5.37489 15.7191 5.37489C12.7796 5.37489 10.8583 7.15647 10.8583 10.3818V13.217H7.59076V16.937H10.8583V25.9299C11.5235 26.0341 12.1958 26.0864 12.8691 26.0862C13.5424 26.0864 14.2147 26.0341 14.8799 25.9299V16.937H17.8786Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5d54da19aad0901e03c02b426647f647.svg";
export { ForwardRef as ReactComponent };